// extracted by mini-css-extract-plugin
export default {"submitSaveAndSend":"_1HYAI5oVWe8Nt5EmqiTXm7 button success"};